module.exports = __webpack_public_path__ + "img/mike.95f97c45.png";